<div
  [ngClass]="{ 'force-mobile-login': $safeNavigationMigration(this.data?.forceMobileLayout), 'login-container': !this.data?.forceMobileLayout }">
  @if (!this.data?.forceMobileLayout) {
  <div class="left-section">
    <div class="left-content-wrapper">
      <h1 class="brand-title">
        {{ 'LOGIN.WELCOME' | transloco }}
      </h1>
    </div>
  </div>
  }

  <div class="right-section" [ngClass]="{ 'show-register': showRegister }">
    <mat-card>
      <mat-card-content>
        @if (!showRegister) {
        <app-login-dialog></app-login-dialog>
        }
        @if (showRegister) {
        <app-signup (userCreatedEvent)="userCreatedEvent($event)"></app-signup>
        }
      </mat-card-content>
      @if (!userCreated && !loginDialog?.showSmsCode) {
      <mat-card-actions class="signup-link">
        <p>
          {{ (showRegister ? 'LOGIN.HAVE_ACCOUNT' : 'LOGIN.NO_ACCOUNT') | transloco }}
          <a (click)="toggleForm()">
            {{ (showRegister ? 'LOGIN.SIGN_IN' : 'LOGIN.SIGN_UP') | transloco }}
          </a>
        </p>
      </mat-card-actions>
      }
    </mat-card>
  </div>
</div>
<!-- @if (!this.data?.forceMobileLayout) {
<app-footer></app-footer>
} -->